"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioVisualizerLoaderFactory = void 0;
var AudioVisualizerLoaderArrayBuffer_1 = require("./AudioVisualizerLoaderArrayBuffer");
var AudioVisualizerLoaderFile_1 = require("./AudioVisualizerLoaderFile");
var AudioVisualizerLoaderURL_1 = require("./AudioVisualizerLoaderURL");
var AudioVisualizerLoaderFactory = /** @class */ (function () {
    function AudioVisualizerLoaderFactory() {
    }
    AudioVisualizerLoaderFactory.newAudioVisualizerLoader = function (audio) {
        var type = typeof audio;
        if (type === 'string') {
            return new AudioVisualizerLoaderURL_1.AudioVisualizerLoaderURL();
        }
        if (type === 'object') {
            if (audio instanceof File) {
                return new AudioVisualizerLoaderFile_1.AudioVisualizerLoaderFile();
            }
            if (audio instanceof ArrayBuffer) {
                return new AudioVisualizerLoaderArrayBuffer_1.AudioVisualizerLoaderArrayBuffer();
            }
        }
        return new AudioVisualizerLoaderURL_1.AudioVisualizerLoaderURL();
    };
    return AudioVisualizerLoaderFactory;
}());
exports.AudioVisualizerLoaderFactory = AudioVisualizerLoaderFactory;
